import { IconDefinition } from "@fortawesome/free-solid-svg-icons";
import MainMenu from "./MainMenu";
import { PropsWithChildren, useState } from "react";
import { Col, Container, Row } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { HeaderButtonBurger } from "../common/header/HeaderButtonBurger";
import { StickyMainHeader } from "../common/header/StickyMainHeader";
import "./ContainerWithHeaderAndMenu.css";

interface Props {
  icon: IconDefinition;
  title: string;
}

export function ContainerWithHeaderAndMenu({
  icon,
  children,
  title,
}: PropsWithChildren<Props>) {
  const [isMainMenuOpen, setIsMainMenuOpen] = useState(false);

  return (
    <>
      <MainMenu
        isMainMenuOpen={isMainMenuOpen}
        setIsMainMenuOpen={setIsMainMenuOpen}
      />

      <Container fluid={true}>
        <StickyMainHeader className="bg-white border-bottom container-with-header-main-header">
          <Row className="py-2">
            <Col className="col-auto d-flex">
              <div className="d-flex with-left-column">
                <HeaderButtonBurger setIsMainMenuOpen={setIsMainMenuOpen} />
              </div>
            </Col>
            <Col className="d-flex align-items-center">
              <h3 className="mb-0 ps-0 page-header-title">
                <FontAwesomeIcon icon={icon} className="me-2" />
                {title}
              </h3>
            </Col>
          </Row>
        </StickyMainHeader>

        <div className="container-with-header-content">{children}</div>
      </Container>
    </>
  );
}
